import { render } from "./navigation-product.vue?vue&type=template&id=f73bab48"
import script from "./navigation-product.vue?vue&type=script&lang=js"
export * from "./navigation-product.vue?vue&type=script&lang=js"

import "./navigation-product.vue?vue&type=style&index=0&id=f73bab48&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__